module.exports = __webpack_public_path__ + "assets/img/confirmBtn.9ad9f755.png";